var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 0C3.80559 0 0 3.80554 0 8.5C0 13.1944 3.80559 17 8.5 17C13.1945 17 17 13.1944 17 8.5C17 3.80554 13.1945 0 8.5 0ZM8.5 15.3C4.75049 15.3 1.7 12.2495 1.7 8.5C1.7 4.75049 4.75049 1.7 8.5 1.7C12.2496 1.7 15.3 4.75049 15.3 8.5C15.3 12.2495 12.2496 15.3 8.5 15.3ZM9.56436 5.1C9.56436 5.71628 9.11565 6.1625 8.50864 6.1625C7.87706 6.1625 7.43936 5.71628 7.43936 5.08821C7.43936 4.48456 7.88891 4.0375 8.50864 4.0375C9.11565 4.0375 9.56436 4.48456 9.56436 5.1ZM7.65186 7.65H9.35186V12.75H7.65186V7.65Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.eb8122f5420b89f424e0e8c23daf7ef3.svg";
export { ForwardRef as ReactComponent };